import DealerDiscount from '@/api/product/dealer-discount'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  dealerTypes: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_CATEGORY(state, data){
    state.categories = data
  },
  SET_DEALER_TYPES(state, data){
    state.dealerTypes = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return DealerDiscount.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return DealerDiscount.store(data)
  },
  destroy(context, data) {
    return DealerDiscount.destroy(data)
  },
  async getDealerType(context){
    let response = await DealerDiscount.getDealerType()
    context.commit('SET_DEALER_TYPES', response.data)
  },
  getProduct(context){
    return DealerDiscount.getProduct()
  }
}
